<!--
 * @Author: zhou.l
 * @Description: 平台店铺档案-单对象，【店铺分类】=旺店通 -> 【对等换货】=是
-->
<template>
  <div class="IS_EQUAL_EXCHANGE">
    <Checkbox id="DEFINE_IS_EQUAL_EXCHANGE" v-model="value" @on-change="change"></Checkbox>
  </div>
</template>

<script>
import service from '@/service/index';

export default {
  data() {
    return {
      value: false,
      STORE_CATEGARY: '',
    };
  },
  computed: {
    /* modify() {
      return $store.state[R3.getModuleName()].updateData.CP_C_SHOP.changeData.STORE_CATEGARY
    } */
  },
  watch: {
    "STORE_CATEGARY": {
      handler(n, o) {
        if (n && n == "Z009") {
          if (!this.value) {
            $('#DEFINE_IS_EQUAL_EXCHANGE input').click()
          }
          // this.value = true
          // this.$emit('change', 'Y');
        } else {
          if (this.value) {
            $('#DEFINE_IS_EQUAL_EXCHANGE input').click()
          }
          // this.value = false
          // vm.$emit('change', 'N');
        }
      },
      immediate: true,
    }
  },
  created() { },
  beforeDestroy() {
    window.removeEventListener('notificationOfMain', () => {});
  },
  mounted() {
    setTimeout(() => {
      if (vm.$route.params.itemId != "New") {
        // const x = vm.$store.state[R3.getModuleName()].updateData.CP_C_SHOP.default.CP_C_SHOP.IS_EQUAL_EXCHANGE
        const form1 = vm.$store.state[R3.getModuleName()].mainFormInfo.formData.data.addcolums[0].childs
        const index = form1.findIndex(i => i.colname == 'IS_EQUAL_EXCHANGE')
        if (index == -1) {
          this.value = false
          return
        }
        const x = form1[index].valuedata
        this.value = x == 'Y'
      }
    }, 700);
    window.addEventListener("notificationOfMain", ({ detail }) => {
      console.log('notificationOfMain::', detail);
      this.STORE_CATEGARY = detail.STORE_CATEGARY
    }, false);
  },
  methods: {
    change(v) {
      console.log('change::', v, this.value);
      this.$emit('change', v === true ? 'Y' : 'N');
    },
  },
};
</script>

<style lang="less" scoped>
</style>
